import { createAsyncThunk } from '@reduxjs/toolkit'
import railsApiService from 'services/api/rails-api-service'

export interface PayWithCreditsParams {
  order_number: string
}

export const payWithCredits = createAsyncThunk(
  'pay-with-credits',
  async ({ order_number }: PayWithCreditsParams, { rejectWithValue }) => {
    try {
      const { data } = await railsApiService.apiInstance.put(`/api/v1/checkouts/${order_number}`)

      return data
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
